import { ValueOf } from '@vy/utils';

export const CREATE_NEW_CONTRACT_STEPS = Object.freeze({
  Details: 0,
  Create: 1,
});

export type CreateNewContractStep = ValueOf<typeof CREATE_NEW_CONTRACT_STEPS>;
